/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

/*
filter state:
  backend Property: FrontEnd Key
*/
export const mapFilterKeys = {
  name: "fname",
  family: "lname",
  dob: "birth",
  "location.name": "location",
  "patientLocation.mrn": "patientLocation.mrn",
  "devices.modelName": "model",
  "devices.serialNumber": "serial",
  "devices.deviceType": "type",
  "devices.manufacturerName": "manufacturer",
  serviceStatus: "serviceStatus",
  patientStatus: "patientStatus",
  authorize: "authorize",
  insuranceName: "insuranceName",
  insuranceType: "insuranceType",
  insuranceStatus: "insuranceStatus",
  updateCount: "updateCount",
  updateDate: "updateDate",
  "followingPhysician.id": "followingPhysician",
  "patient.subLocation": "subLocation",
};

export const mapFilterKeysForPatientReport = {
  fname: "fname",
  lname: "lname",
  dob: "dob",
  "location.name": "location",
  "patientLocation.mrn": "patientLocation.mrn",
  model: "model",
  serial: "serial",
  type: "type",
  manufacturer: "manufacturer",
  serviceStatus: "serviceStatus",
  patientStatus: "patientStatus",
  authorize: "authorize",
  insuranceName: "insuranceName",
  insuranceType: "insuranceType",
  insuranceStatus: "insuranceStatus",
  updateCount: "updateCount",
  updateDate: "updateDate",
  followingPhysician: "followingPhysician",
  subLocation: "subLocation",
};

/*
frontendKey: backend props
*/
export const mapKeyFilters = {
  fname: { key: "name", com: "$lk" },
  lname: { key: "family", com: "$lk" },
  birth: { key: "dob", com: "$eq" },
  location: { key: "patientLocation.location.name", com: "$eq" },
  "patientLocation.mrn": { key: "patientLocation.mrn", com: "$lk" },
  model: { key: "devices.modelName", com: "$lk" },
  serial: { key: "devices.serialNumber", com: "$lk" },
  type: { key: "devices.deviceType", com: "$eq" },
  manufacturer: { key: "devices.manufacturerName", com: "$eq" },
  serviceStatus: { key: "serviceStatus", com: "$eq" },
  patientStatus: { key: "status", com: "$eq" },
  authorize: { key: "authorize", com: "$eq" },
  insuranceName: { key: "insuranceName", com: "$lk" },
  insuranceStatus: { key: "status", com: "$eq" },
  insuranceType: { key: "insuranceType", com: "$eq" },
  updateCount: { key: "updateCount", com: "$eq" },
  updateDate: { key: "updateDate", com: "$gte" },
  followingPhysician: { key: "followingPhysician.id", com: "$eq" },
  subLocation: { key: "patient.subLocation", com: "$eq" },
};

export const mapKeyFiltersForPatientReport = {
  fname: { key: "name", com: "$lk" },
  lname: { key: "family", com: "$lk" },
  dob: { key: "dob", com: "$eq" },
  location: { key: "patientLocationName", com: "$eq" },
  "patientLocation.mrn": { key: "patientLocationMrn", com: "$lk" },
  model: { key: "deviceModelName", com: "$lk" },
  serial: { key: "deviceSerialNumber", com: "$lk" },
  type: { key: "deviceType", com: "$lk" },
  manufacturer: { key: "deviceManufacturerName", com: "$lk" },
  serviceStatus: { key: "serviceStatus", com: "$eq" },
  patientStatus: { key: "patientStatus", com: "$eq" },
  authorize: { key: "authorize", com: "$eq" },
  insuranceName: { key: "insuranceName", com: "$lk" },
  insuranceStatus: { key: "status", com: "$eq" },
  insuranceType: { key: "insuranceType", com: "$eq" },
  updateCount: { key: "updateCount", com: "$eq" },
  updateDate: { key: "updateDate", com: "$gte" },
  followingPhysician: { key: "followingPhysicianId", com: "$eq" },
  subLocation: { key: "subLocation", com: "$eq" },
};

export const mapKeyFiltersForInsurrance = {
  fname: { key: "patient.name", com: "$lk" },
  lname: { key: "patient.family", com: "$lk" },
  birth: { key: "patient.dob", com: "$eq" },
  location: { key: "patient.patientLocation.location.name", com: "$eq" },
  "patientLocation.mrn": { key: "patient.patientLocation.mrn", com: "$lk" },
  model: { key: "patient.devices.modelName", com: "$lk" },
  serial: { key: "patient.devices.serialNumber", com: "$lk" },
  type: { key: "patient.devices.deviceType", com: "$eq" },
  manufacturer: { key: "patient.devices.manufacturerName", com: "$eq" },
  serviceStatus: { key: "patient.serviceStatus", com: "$eq" },
  patientStatus: { key: "patient.status", com: "$eq" },
  authorize: { key: "patient.authorize", com: "$eq" },
  insuranceName: { key: "insuranceName", com: "$lk" },
  insuranceStatus: { key: "status", com: "$eq" },
  insuranceType: { key: "insuranceType", com: "$eq" },
  updateCount: { key: "updateCount", com: "$eq" },
  updateDate: { key: "updateDate", com: "$gte" },
  followingPhysician: { key: "patient.followingPhysician.id", com: "$eq" },
  subLocation: { key: "patient.subLocation", com: "$eq" },
};
